
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycarrentalcabserviceinpune() {



const cardData =
{
  keyword: 'Monthly Car Rental Cab Service in Pune',
  heading: 'eTravo: Monthly Car Rental Cab Service in Pune',
  headingDescription: 'eTravo offers flexible and affordable monthly car rental services in Pune, specially crafted for corporate use, employee commutes, and long-term business needs. Whether your organization requires dedicated cabs for daily office travel, executive mobility, or long-term staff transport, we provide a wide range of vehicles from sedans to SUVs and premium cars. Our monthly cab plans include professional chauffeurs, regular vehicle maintenance, GPS tracking, fuel options, and 24/7 customer support. With fixed monthly pricing and scalable solutions, eTravo is the go-to choice for businesses seeking reliable and cost-effective transport for their workforce.',

  top: 'Top Corporate Areas in Pune Served by Monthly Cab Services',
  topPlaces: [
    {
      title: 'Magarpatta City',
      description: 'A prominent business township with corporate offices, BPOs, and IT parks. eTravo’s monthly cab rentals are popular among companies here for transporting employees across multiple shifts and ensuring executive-level comfort for top management throughout the month.'
    },
    {
      title: 'Hinjewadi IT Park',
      description: 'The largest IT hub in Pune, hosting companies like Infosys, TCS, and Cognizant. Our long-term cab rental plans are widely used for transporting tech professionals and senior consultants with flexible timing and GPS-monitored rides.'
    },
    {
      title: 'Kharadi (EON IT Park)',
      description: 'Known for housing multinational companies and tech startups, Kharadi demands dependable daily transport. eTravo provides full-month cab rentals here with structured pickup points, live driver updates, and a dedicated support team.'
    },
    {
      title: 'Viman Nagar',
      description: 'An upscale commercial-residential area close to Pune Airport, ideal for housing executives and visiting staff. Our premium car rentals for corporates in Viman Nagar include chauffeur-driven cabs and flexible mileage options under monthly contracts.'
    },
    {
      title: 'Baner-Balewadi Business District',
      description: 'With growing office spaces and coworking hubs, this zone is emerging as a hotspot for monthly cab use. Our clients here include marketing agencies, law firms, and real estate consultancies requiring regular executive mobility.'
    },
    {
      title: 'Yerwada Business Zone',
      description: 'Yerwada includes several top hotels and corporate campuses, where long-term cab services are used for leadership teams and frequent airport transfers. Our monthly rentals ensure privacy, punctuality, and premium vehicle availability.'
    },
    {
      title: 'Shivajinagar & Deccan',
      description: 'This central commercial area hosts legal firms, academic consultancies, and financial institutions. eTravo provides monthly sedan and hatchback services here for routine inter-office and inter-city trips.'
    },
    {
      title: 'Hadapsar',
      description: 'A key location for industrial operations and IT firms like Accenture and Mphasis. Our monthly cab rental solutions in Hadapsar support both employee commutes and management travel through pre-scheduled, recurring plans.'
    },
    {
      title: 'Koregaon Park',
      description: 'Preferred by executives and startup founders for its business lounges and fine-dining meeting spots. Our luxury cab rentals in this area include executive packages with monthly billing, priority dispatch, and airport add-ons.'
    },
    {
      title: 'Pune Airport (Lohegaon)',
      description: 'A high-traffic transit point for corporate flyers. Companies operating here rely on eTravo’s monthly cab services to streamline pick-up and drop logistics for traveling employees, minimizing costs through subscription-based transport.'
    }
  ],

  services: [
    {
      name: 'Monthly Corporate Car Rental Pune',
      description: 'Our dedicated monthly rental service provides corporates with private vehicles for uninterrupted daily transportation. Suitable for leadership mobility, team commutes, and field visits, it comes with driver, fuel plans, and priority service—all billed monthly.'
    },
    {
      name: 'Long-Term Cab Hire Pune',
      description: 'Ideal for startups, SMEs, and large enterprises needing continuous cab availability without the burden of ownership. Our long-term cab hire includes branded or unbranded vehicles based on your preference, allowing fleet-like reliability without capital investment.'
    },
    {
      name: 'Employee Monthly Cab Service Pune',
      description: 'We manage monthly cab schedules for HR and admin teams, ensuring employees reach on time every day. Routes, driver IDs, trip logs, and vehicle health reports are regularly to keep corporate transportation transparent and secure.'
    },
    {
      name: 'Corporate Monthly Cab Rentals Pune',
      description: 'Perfect for companies running multiple offices or facilities. Our cab rentals adapt to daily staff flow, offering backup vehicles and standby drivers to maintain consistency in operations throughout the month.'
    },
    {
      name: 'Affordable Monthly Car Hire Pune',
      description: 'We offer pricing plans that include or exclude fuel, based on your need. With fixed billing cycles and GST invoicing, this service is designed to offer maximum value for corporate transport with zero hidden charges.'
    },
    {
      name: 'Monthly Staff Cab Service Pune',
      description: 'A hassle-free solution for daily staff transportation using AC cabs with trained chauffeurs. Staff enjoy consistent routes, while companies benefit from punctuality and reduced absenteeism.'
    },
    {
      name: 'Corporate Lease Car Service Pune',
      description: 'For companies needing vehicles without ownership liabilities, our lease model provides insured and roadworthy vehicles with full servicing included. We also offer mid-contract vehicle upgrades and brand customization options.'
    },
    {
      name: 'Monthly Business Car Rentals Pune',
      description: 'Our business-focused packages are tailored for sales teams, client service agents, and senior executives who travel daily across Pune. We offer vehicle options including compact sedans, Innovas, and high-end models depending on business needs.'
    },
    {
      name: 'Long-Term Employee Transport Pune',
      description: 'Suitable for companies with shift-based staffing or operations running late hours. We provide dedicated cars for groups or individual professionals with route optimization and 24x7 travel support.'
    },
    {
      name: 'Monthly Executive Cab Pune',
      description: 'Built for top-level professionals, our executive plans feature silent cabins, rear AC controls, ambient lighting, and discreet chauffeurs. Ideal for CEOs, VPs, and business guests requiring high-end car travel on contract.'
    },
    {
      name: 'Reliable Monthly Cab Pune',
      description: 'Our reliability is built on daily vehicle checks, professional drivers, on-call service managers, and instant replacement support. We assign dedicated route managers to companies with complex scheduling needs.'
    },
    {
      name: 'Flexible Monthly Car Hire Pune',
      description: 'Choose your car, modify your routes mid-month, or change drivers if required—our service is built to adjust to your evolving business needs. We offer short-notice replacements and 3-tier support to keep your teams moving.'
    },
    {
      name: 'Staff Commute Monthly Service Pune',
      description: 'Designed for organizations looking to optimize employee travel budgets, this service ensures reduced cab fare over time and consistent attendance, especially for teams in BPOs, banks, and logistic hubs.'
    },
    {
      name: 'Monthly Vehicle Rental Pune',
      description: 'Whether it’s for a corporate event team or a rotating pool of employees, our monthly vehicle rental service offers dependable access to cars without daily coordination. Just one contract, and your transport is covered for 30+ days.'
    },
    {
      name: 'Corporate Subscription Cab Pune',
      description: 'Our subscription model allows businesses to select cab types, travel limits, driver hours, and route preferences under a fixed monthly package—perfect for growing companies looking to stabilize transport costs and improve planning.'
    }
  ],

  tableData: [
    ['Monthly Corporate Car Rental Pune', 'Long-Term Cab Hire Pune'],
    ['Employee Monthly Cab Service Pune', 'Corporate Monthly Cab Rentals Pune'],
    ['Affordable Monthly Car Hire Pune', 'Monthly Staff Cab Service Pune'],
    ['Corporate Lease Car Service Pune', 'Monthly Business Car Rentals Pune'],
    ['Long-Term Employee Transport Pune', 'Monthly Executive Cab Pune'],
    ['Reliable Monthly Cab Pune', 'Flexible Monthly Car Hire Pune'],
    ['Staff Commute Monthly Service Pune', 'Monthly Vehicle Rental Pune'],
    ['Corporate Subscription Cab Pune', '']
  ],





"whychoose": [
    {
        "WhyChooseheading": "Affordable Monthly Car Rentals for Corporates",
        "WhyChoosedescription": "eTravo offers flexible and budget-friendly monthly cab rental plans for businesses in Pune. Perfect for companies with ongoing transport needs like employee mobility, client visits, and executive commutes."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles for Monthly Use",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and MPVs based on your requirements. Whether it’s a compact car for daily errands or a luxury sedan for executives—we have a vehicle for every business need."
    },
    {
        "WhyChooseheading": "Chauffeur-Driven or Self-Drive Options",
        "WhyChoosedescription": "Depending on your preference, we provide both chauffeur-driven cars and self-drive rentals. Our drivers are trained, punctual, and experienced in corporate protocols."
    },
    {
        "WhyChooseheading": "No Long-Term Commitment, Cancel Anytime",
        "WhyChoosedescription": "Enjoy the flexibility of using a car for a month without the burden of owning or leasing long-term. Cancel, upgrade, or downgrade anytime based on your changing business needs."
    },
    {
        "WhyChooseheading": "Fuel-Inclusive and Exclusive Plans Available",
        "WhyChoosedescription": "Our monthly car rental service includes packages with or without fuel, giving you complete control over your operational costs and billing preferences."
    },
    {
        "WhyChooseheading": "All-Inclusive Maintenance and Support",
        "WhyChoosedescription": "No need to worry about breakdowns or service issues. eTravo handles vehicle maintenance, insurance, and regular servicing throughout your rental period."
    },
    {
        "WhyChooseheading": "GPS Tracking and Ride Monitoring",
        "WhyChoosedescription": "Every vehicle is GPS-enabled for real-time monitoring. Get complete control and visibility of car usage across your departments or branches."
    },
    {
        "WhyChooseheading": "Monthly GST Billing and Custom Reports",
        "WhyChoosedescription": "We provide GST-compliant invoices with trip logs and custom reporting options to help HR, admin, or accounts teams monitor transport expenses accurately."
    }
]
}


const faqData = [
    [
        {
            question: 'What is included in eTravo’s monthly car rental service?',
            answer: 'Our service includes the car, driver (optional), maintenance, insurance, and optional fuel coverage—ideal for corporate teams, executives, and operational staff.'
        },
        {
            question: 'Can we choose the car model for monthly use?',
            answer: 'Yes, you can choose from multiple car types including Swift Dzire, Honda Amaze, Innova Crysta, Ertiga, and more—based on your usage and budget.'
        },
        {
            question: 'Is there a minimum commitment for monthly rentals?',
            answer: 'No long-term commitments required. You can book for 30 days and extend, modify, or cancel based on your organization’s needs.'
        },
        {
            question: 'Can we track the usage and routes of the car?',
            answer: 'Yes, GPS tracking is available for all cars. You can monitor trips, get usage history, and ensure timely reporting for admin or HR teams.'
        },
        {
            question: 'Are fuel costs included in the monthly rental?',
            answer: 'We offer both fuel-inclusive and fuel-exclusive plans. You can select the option that suits your company’s reimbursement or cost structure.'
        },
        {
            question: 'Will we get monthly invoices with GST for our company?',
            answer: 'Absolutely. We provide monthly GST-compliant invoices with itemized service breakdowns for easy documentation and tax compliance.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Sameer Desai',
        designation: 'Operations Lead, AxisCom Logistics',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s monthly cab service for over a year now. It’s convenient, affordable, and saves us the hassle of managing company cars internally.”'
    },
    {
        name: 'Ms. Richa Nimbalkar',
        designation: 'HR Executive, Welserve IT Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“Their monthly rental plan is a blessing for our field team. Cars are reliable, billing is transparent, and the support is always on point.”'
    }
];

















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Car Rental Cab Service in Pune",
  "image": "https://www.etravo.in/images/keyword/monthly-car-rental-cab-pune.jpg",
  "description": "Book monthly car rental cab services in Pune with eTravo. Ideal for corporate leases, long-term employee transport, and flexible monthly car hire. Affordable plans, reliable service, and professional drivers for your business needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7653"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-car-rental-cab-service-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Monthly Car Rental Cab Service in Pune | Corporate & Long-Term Hire | eTravo</title>
  <meta 
    name="description" 
    content="Hire monthly car rental cab services in Pune for corporate employees, long-term leases, and flexible monthly plans. Reliable and affordable corporate car hire by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycarrentalcabserviceinpune;